"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var SubHeader_1 = __importDefault(require("../../../../common/SubHeader"));
var HeaderBar_1 = __importDefault(require("../../../../theme/headerbar/HeaderBar"));
var AreaMappingCountReport_1 = __importDefault(require("./AreaMappingCountReport"));
var AreaMappingListReport_1 = __importDefault(require("./AreaMappingListReport"));
var InstallationReport_1 = __importDefault(require("./InstallationReport"));
var KnowledgeWatchedVideo_1 = __importDefault(require("./KnowledgeWatchedVideo"));
var ParticipantReport_1 = __importDefault(require("./ParticipantReport"));
var SensitationWatchedVideo_1 = __importDefault(require("./SensitationWatchedVideo"));
var SynchronizationReport_1 = __importDefault(require("./SynchronizationReport"));
var headerList = [
    {
        name: 'general',
        menu: [
            {
                name: 'app_installation',
                key: 'app_installation',
            },
            {
                name: 'synchronization',
                key: 'synchronization',
            },
        ],
    },
    {
        name: 'guide',
        menu: [
            {
                name: 'guide_watched_video_count',
                key: 'guide_watched_video_count',
            },
        ],
    },
    {
        name: 'knowledge',
        menu: [
            {
                name: 'knowledge_watched_video_count',
                key: 'knowledge_watched_video_count',
            },
        ],
    },
    {
        name: 'participant',
        menu: [
            {
                name: 'participant',
                key: 'participant',
            },
        ],
    },
    {
        name: 'area_mapping',
        menu: [
            {
                name: 'area_mapping_list',
                key: 'area_mapping_list',
            },
            {
                name: 'area_mapping_count',
                key: 'area_mapping_count',
            },
        ],
    },
];
var GeneralReport = function (props) {
    var _a = (0, react_1.useState)(''), subType = _a[0], setSubType = _a[1];
    var _b = (0, react_1.useState)(headerList[0]), type = _b[0], setType = _b[1];
    var renderForm = function () {
        if (subType === 'app_installation') {
            return react_1.default.createElement(InstallationReport_1.default, null);
        }
        else if (subType === 'synchronization') {
            return react_1.default.createElement(SynchronizationReport_1.default, null);
        }
        else if (subType === 'guide_watched_video_count') {
            return react_1.default.createElement(SensitationWatchedVideo_1.default, null);
        }
        else if (subType === 'knowledge_watched_video_count') {
            return react_1.default.createElement(KnowledgeWatchedVideo_1.default, null);
        }
        else if (subType === 'area_mapping_list') {
            return react_1.default.createElement(AreaMappingListReport_1.default, null);
        }
        else if (subType === 'area_mapping_count') {
            return react_1.default.createElement(AreaMappingCountReport_1.default, null);
        }
        else if (subType === 'participant') {
            return react_1.default.createElement(ParticipantReport_1.default, null);
        }
    };
    var renderBody = function () {
        return (react_1.default.createElement(react_1.default.Fragment, null, type.menu.length > 0 && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(SubHeader_1.default, { path: "".concat(props.match.path), list: type.menu, onSubChangeTab: function (val) {
                    setSubType(val.name);
                } }),
            subType !== '' && renderForm()))));
    };
    return (react_1.default.createElement(HeaderBar_1.default, { list: headerList, alias: 'report', hideSave: true, path: "".concat(props.match.path), title: 'report', onChangeTab: function (val) {
            setType(val);
            setSubType(null);
        } }, renderBody()));
};
exports.default = GeneralReport;
